const changeUrl = (history, url) => {
	history.push(url);
};

export default changeUrl;
